import type {AlbumPhotoFaceProps, AlbumPhotoSortBy, AttrMultiWatermark, PhotoOutlineProps, SortType, DownPhotoQuality} from '@/views/props'
import {defineStore} from 'pinia'

interface Props {
    albumId: string
    photoList: PhotoOutlineProps[]
    pages: number
    pageSize: number
    labelId: number
    sortBy: AlbumPhotoSortBy
    sortType: SortType
    albumWatermark: AttrMultiWatermark[]
    currentIndex: number
    personList: AlbumPhotoFaceProps[]
    personId: string
    showPerson: boolean
    showWatermark: boolean
    downPhotoQuality: DownPhotoQuality
    debug: boolean
    puzzle: boolean
    formMini: boolean
    gatherId: string
    sharePoster: boolean
    cndUrl: string
    processUrl: string
    loadingUrl: string
    loadingSize: number
    openPhotoHome: boolean
    openUserHome: boolean
    screenWidth: number | undefined
    screenHeight: number | undefined
    userHomeId: number | undefined
    openId: string | undefined
    payPhotoType: 'NONE' | 'PAY_PHOTO' | 'SELECT_PHOTO'
    canDownload: boolean
    vote: boolean
    voteStartTime: string
    voteEndTime: string
    voteResult: boolean
    forceMode: 'NONE' | 'FACE' | 'NUMBER' | 'FILE_NAME'
    forceModeDesc:''
}

export const useAlbumStore = defineStore({
    id: 'album',

    state: (): Props => ({
        albumId: '',
        photoList: [],
        pages: 0,
        pageSize: 50,
        labelId: 0,
        sortBy: 'CAPTURE_TIME',
        sortType: 'DESC',
        albumWatermark: [],
        currentIndex: 0,
        personList: [],
        personId: '',
        showPerson: true,
        showWatermark: true,
        downPhotoQuality: 'ORIGIN',
        debug: false,
        puzzle: false,
        formMini: false,
        gatherId: '',
        sharePoster: false,
        cndUrl: '',
        processUrl: '',
        // albumLoading: true,
        openPhotoHome: false, // 图片详情页的个人主页入口是否显示
        openUserHome: false, // 相册首页的个人主页入口是否显示
        screenWidth: undefined, // 屏幕宽度
        screenHeight: undefined, // 屏幕高度
        userHomeId: undefined,
        openId: undefined,
        // payPhoto: false,  // 是否开启付费
        canDownload: false,
        payPhotoType: 'NONE',
        loadingUrl: '',
        loadingSize: 50,
        vote: false,
        voteStartTime: '',
        voteEndTime: '',
        voteResult: false,
        forceMode: 'NONE',
        forceModeDesc:''
    }),
    // 开启数据持久化
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'store',
                storage: sessionStorage
            }
        ]
    },
    getters: {
        getAlbumId: (state: Props) => state.albumId,
        getPhotoList: (state: Props) => state.photoList,
        getPersonList: (state: Props) => state.personList
    },
    actions: {
        setScreenWidth(newValue) {
            this.screenWidth = newValue
        },
        setScreenHeight(newValue) {
            this.screenHeight = newValue
        }
    }
})
